import { Input, Select, theme } from "antd";
import { useEffect, useState } from "react";

export const InputUnitComponent = ({
  name,
  type,
  placeholder,
  units = [],
  initialValue,
  initialUnit,
  onChange,
}) => {
  const {
    token: { colorText },
  } = theme.useToken();
  const [value, setValue] = useState(initialValue);
  const [unit, setUnit] = useState(initialUnit);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    setUnit(initialUnit);
  }, [initialUnit]);

  return (
    <Input
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={(e) => {
        const newValue = e.target.value;
        setValue(newValue);
        onChange?.({ value: newValue, unit });
      }}
      addonAfter={
        <Select
          value={unit}
          style={{ width: 100, margin: 0, color: colorText }}
          onChange={(selectedUnit) => {
            setUnit(selectedUnit);
            onChange?.({ value, unit: selectedUnit });
          }}
        >
          {units.map((unit) => (
            <Select.Option key={unit} value={unit}>
              {unit}
            </Select.Option>
          ))}
        </Select>
      }
    />
  );
};
